<template>
  <v-row>
    <v-col>
      <v-card shaped>
        <v-row>
          <v-col>
            <v-card-title>
              Employee Information
            </v-card-title>
            <v-list rounded disabled>
              <v-list-item-group v-model="item" color="primary">
                <v-list-item
                  v-for="(item, i) in listItemsCol1"
                  :key="i"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle v-text="item.text">
                    </v-list-item-subtitle>
                    <v-list-item-title v-text="employee.fields[item.text]">
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col>
            <v-list rounded disabled>
              <v-list-item-group v-model="item" color="primary">
                <v-subheader></v-subheader>
                <v-list-item
                  v-for="(item, i) in listItemsCol2"
                  :key="i"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle v-text="item.text">
                    </v-list-item-subtitle>
                    <v-list-item-title v-text="employee.fields[item.text]">
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col class="shrink">
      <v-card shaped>
        <v-row>
          <v-col>
            <v-card-title>
              Training
            </v-card-title>
            <v-list rounded shaped disabled>
              <v-list-item-group v-model="item" color="primary">
                <v-list-item
                  v-for="(item, i) in listItemsCol3"
                  :key="i"
                >
                  <v-list-item-icon>
                    <v-icon :color="item.icon.color" v-text="item.icon.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle v-text="item.title">
                    </v-list-item-subtitle>
                    <v-list-item-title v-text="item.text">
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'EmployeeInfoList',
    props: {
      employee: Object,
      employees: Array
    },
    data () {
      return {
        item: null,
        errorIcon: {
          icon: 'mdi-alert-circle',
          color: 'error'
        },
        successIcon: {
          icon: 'mdi-check-circle'
        },
        listItemsCol1: [
          { text: 'Title', icon: 'mdi-briefcase' },
          { text: 'Location', icon: 'mdi-map-marker' },
          { text: 'Email', icon: 'mdi-email' },
        ],
        listItemsCol2: [
          { text: 'Department', icon: 'mdi-sitemap' },
          { text: 'Hire Date', icon: 'mdi-calendar' },
          { text: 'Manager Email', icon: 'mdi-account-supervisor' }
        ]
      }
    },
    computed: {
      directReports () {
        return this.employees.filter(e => {
          return e.fields['Manager Email'] === this.employee.fields.Email
        })
      },
      managerTrainingStatus () {
        const status = { title: 'Manager Training' }
        if (this.employee.fields['Latest Manager Training']) {
          status.text = this.employee.fields['Latest Manager Training']
          status.icon = this.successIcon
        } else if (this.directReports.length === 0) {
          status.text = 'Not Required'
          status.icon = this.successIcon
        } else {
          status.text = 'Required'
          status.icon = this.errorIcon
        }
        return status
      },
      sexualHarassmentTrainingStatus () {
        const status = { title: 'Sexual Harassment Training' }
        if (this.employee.fields['Latest Sexual Harassment Training']) {
            status.text = this.employee
                           .fields['Latest Sexual Harassment Training']
            status.icon = this.successIcon
        } else {
          status.text = 'Required'
          status.icon = this.errorIcon
        }
        return status
      },
      diversityTrainingStatus () {
        const status = { title: 'Diversity Training' }
        if (this.employee.fields['Latest Diversity Training']) {
          status.text = this.employee.fields['Latest Diversity Training']
          status.icon = this.successIcon
        } else {
          status.text = 'Required'
          status.icon = this.errorIcon
        }
        return status
      },
      covid19TrainingStatus () {
        const status = { title: 'COVID-19 Training' }
        if (this.employee.fields['Latest COVID-19 Training']) {
          status.text = this.employee.fields['Latest COVID-19 Training']
          status.icon = this.successIcon
        } else if (this.employee.fields['Location Formatted'] === 'Remote') {
          status.text = 'Not Required'
          status.icon = this.successIcon
        } else {
          status.text = 'Required'
          status.icon = this.errorIcon
        }
        return status
      },
      listItemsCol3 () {
        return [
          this.sexualHarassmentTrainingStatus, 
          this.managerTrainingStatus,
          this.diversityTrainingStatus,
          this.covid19TrainingStatus
        ]
      }
    }
  }
</script>
